module.exports = __webpack_public_path__ + "img/chofu_halfticket_off.683258c4.svg";